import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';
import { ROUTES } from '../server-route';
import { BehaviorSubject } from 'rxjs';


export interface LocationData {
  state: string;
  district: string;
  pincode: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http: HttpClient) { }

  getCurrentPosition(): Observable<any> {
    return new Observable((observer) => {
      if ('geolocation' in navigator) {

        const options: PositionOptions = {
          enableHighAccuracy: false,  // Use true if you need more accuracy
          timeout: 5000,              // Timeout after 5 seconds
          maximumAge: 60000           // Use cached data if it's less than 1 minute old
        };
        navigator.geolocation.getCurrentPosition(
          (position) => {
            observer.next(position);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          },
          options
        );
      } else {
        observer.error('Geolocation is not available in this browser.');
      }
    });
    
  }

isLocationGranted(): Observable<boolean> {
  return new Observable((observer) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Emit true when location is granted
          observer.next(true);
          observer.complete();
        },
        (error) => {
          // Emit false when location is denied
          observer.next(false);
          observer.complete();
        }
      );
    } else {
      // Emit false when geolocation is not supported
      observer.next(false);
      observer.complete();
    }
  });
}


 private readonly initialLocation: LocationData = {
    state: '',
    district: '',
    pincode: '',
  };

  private readonly locationSubject =
    new BehaviorSubject<LocationData>(this.initialLocation);

  readonly location$ = this.locationSubject.asObservable();

  get location(): LocationData {
    return this.locationSubject.value;
  }

  setLocation(data: Partial<LocationData>): void {
    this.locationSubject.next({
      ...this.locationSubject.value,
      ...data,
    });
  }

  setState(state: string): void {
    this.setLocation({
      state,
      district: '',
      pincode: '',
    });
    console.log(state, 'loc state');
    
  }

  setDistrict(district: string): void {
    
    this.setLocation({
      district,
      pincode: '',
    });
    console.log(this.location, 'loc dist');
  }

  setPincode(pincode: string): void {
    this.setLocation({ pincode });
    console.log(pincode, 'loc pin');
    
  }

  clearLocation(): void {
    this.locationSubject.next(this.initialLocation);
  }

  
}